import * as React from "react";
import { axiosReq, capitalize, dateFormat } from "../utils/functions";
// import LogoSGPools from "../assets/image/logo.png";
import LogoSGPools from "../assets/image/fatcat.png";
// import Btn4d from "../assets/image/4d-btn.jpg";
// import BtnToto from "../assets/image/toto-btn.jpg";
import {
	BottomNavigation,
	BottomNavigationAction,
	Grid,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Button,
	Typography,
	Box,
	Tabs,
	Tab,
	AppBar,
	Container,
} from "@material-ui/core";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PaymentIcon from "@material-ui/icons/Payment";
import { Link, useHistory, useParams } from "react-router-dom";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useDispatch } from "react-redux";
import { emptyThankYou } from "../redux/items/ThankYou";
import { emptyThankYouDetail } from "../redux/items/ThankYouDetails";
import { resetReferLogin } from "../redux/items/ReferLogin";
import bow from "../assets/image/bow.png";
import BottomFloat from "../components/containers/BottomFloat";
import style from "../assets/css/style";
import { setDrawSet } from "../redux/items/DrawSet";
import { useSelector } from "react-redux";
import FetchLogin from "../components/Fetch/FetchLogin";
import { showMaintenance } from "../redux/items/Maintenance";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

var parts = window.location.search.substr(1).split("&");
var $_GET = {};
for (var i = 0; i < parts.length; i++) {
	var temp = parts[i].split("=");
	$_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}
function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

const Home2 = observer(() => {
	const hist = useHistory();
	const dispatch = useDispatch();
	const params = useParams();
	const token = useSelector((state) => state.login.token);

	const v = useLocalObservable(() => ({
		openHowToClaim: false,
		openHowToPlay: false,
		fourDPrizeModal: false,
		referralMessage: "",
		referralMessageColor: "",
	}));
	const [value, setValue] = React.useState(0);

	const enable_book_4d = useSelector(
		(state) => state.drawSet.set?.enable_book_4d === 1
	);
	const enable_book_toto = useSelector(
		(state) => state.drawSet.set?.enable_book_toto === 1
	);
	const timeCutOff = useSelector((state) => state.drawSet.set?.timeCutOff);
	const nextTwoDraw = useSelector((state) => state.drawSet?.nextTwoDraw);
	const image_cache = useSelector((state) => state.drawSet.set?.image_cache);
	const prize4d = useSelector((state) => state.drawSet?.prize4d);
	const user = useSelector((state) => state.login?.user);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const reqInfo = FetchLogin("info", {
		callback: () => {
			hist.push("/");
		},
	});

	React.useEffect(() => {
		(async () => {
			let ret = await axiosReq("draw-set");

			if (ret?.maintenance) dispatch(showMaintenance());

			dispatch(setDrawSet(ret.data.drawSet));
		})();

		dispatch(emptyThankYou());
		dispatch(emptyThankYouDetail());
		dispatch(resetReferLogin());

		if (params.code !== undefined) {
			(async () => {
				v.referralMessageColor = "";
				let ret = await axiosReq("refer-confirm", {
					refer_code: params.code,
				});

				if (ret.status === "success") v.referralMessageColor = "green";
				else v.referralMessageColor = "red";

				v.referralMessage = ret.message;

				// console.log(ret);
			})();
		}

		if ($_GET.token !== undefined) {
			reqInfo.handleTrigger({ token: $_GET.token });
		}

		// alert(document.location.origin);
		// alert(document.location.hostname);
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<Container
				maxWidth="sm"
				style={{
					backgroundColor: "#f7f7f7",
					// height: "100vh",
					color: "#676767",
					display: "flex",
					flexDirection: "column",
					position: "relative",
					height:
						"calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top))",
				}}
			>
				<div style={{ padding: "12px 24px", backgroundColor: "#fff" }}>
					<Grid container>
						<Grid
							item
							xs={2}
							container
							alignItems="center"
							justifyContent="center"
						>
							<img
								src={
									process.env.REACT_APP_YES_APP === undefined
										? LogoSGPools
										: process.env.REACT_APP_ASSETS3 + "logo.png?d=xxxxxxx"
								}
								alt={process.env.REACT_APP_NAME}
								style={{ width: 80 }}
							/>
						</Grid>
						<Grid item xs={10} style={{ padding: "10px 0" }}>
							<div style={{ color: style.color }}>
								Draw type:{" "}
								{nextTwoDraw !== undefined && (
									<span
										style={{
											fontStyle: "italic",
										}}
									>
										{dateFormat("Y-m-d H:i:s") < timeCutOff
											? nextTwoDraw[0].type === "4d"
												? "4D"
												: "Toto"
											: nextTwoDraw[1].type === "4d"
											? "4D"
											: "Toto"}
									</span>
								)}
							</div>
							<div style={{ color: style.color }}>
								Upcoming Draw:{" "}
								{nextTwoDraw !== undefined && (
									<span style={{ fontStyle: "italic" }}>
										{dateFormat("Y-m-d H:i:s") < timeCutOff
											? dateFormat("d F Y", nextTwoDraw[0].date) +
											  ", " +
											  nextTwoDraw[0].week
											: dateFormat("d F Y", nextTwoDraw[1].date) +
											  ", " +
											  nextTwoDraw[1].week}
									</span>
								)}
							</div>
						</Grid>
					</Grid>
				</div>
				<div style={{ height: "50%" }}>
					{process.env.REACT_APP_YES_APP !== undefined && !token ? (
						<img
							src={
								process.env.REACT_APP_BASE_IMAGE_URL +
								"/app-banner.jpg?c=" +
								image_cache
							}
							alt={process.env.REACT_APP_NAME + " Banner"}
							style={{ width: "100%", height: "100%" }}
						/>
					) : (
						<img
							src={
								process.env.REACT_APP_BASE_IMAGE_URL +
								"/banner.jpg?c=" +
								image_cache
							}
							alt={process.env.REACT_APP_NAME + " Banner"}
							style={{ width: "100%", height: "100%" }}
						/>
					)}
				</div>
				<div
					style={{
						padding: 24,
						height: "100%",
					}}
				>
					<Grid
						container
						spacing={6}
						style={{
							// backgroundColor: "red",
							height: "100%",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						{enable_book_4d && (
							<Grid
								item
								xs={6}
								style={{ cursor: "pointer" }}
								onClick={() => hist.push("/place-bet")}
							>
								<img
									src={process.env.REACT_APP_ASSETS3 + "toto-btn.jpg?d=xxxxxxx"}
									alt="4d"
									style={{
										width: "100%",
										height: "120%",
										borderRadius: 8,
										boxShadow: "1px 2px 8px 1px #888",
									}}
								/>
								<span
									style={{
										backgroundColor: "#fff",
										color: "#fff",
										textTransform: "uppercase",
										padding: "16px",
										width: "65%",
										display: "block",
										textAlign: "center",
										margin: "0 auto",
										fontWeight: "bold",
										borderRadius: 30,
										marginTop: "-23%",
										zIndex: 1,
										position: "relative",
									}}
								></span>
								<span
									style={{
										backgroundColor: style.color,
										color: "#fff",
										textTransform: "uppercase",
										padding: "16px",
										width: "65%",
										display: "block",
										textAlign: "center",
										margin: "0 auto",
										fontWeight: "bold",
										borderRadius: 30,
										marginTop: "-5%",
										zIndex: 1,
										position: "relative",
									}}
								>
									buy
								</span>
							</Grid>
						)}
						{enable_book_toto && (
							<Grid
								item
								xs={6}
								style={{ cursor: "pointer" }}
								onClick={() => {
									hist.push("/toto");
								}}
							>
								<img
									src={process.env.REACT_APP_ASSETS3 + "4d-btn.jpg?d=xxxxxxx"}
									alt="4d"
									style={{
										width: "100%",
										height: "120%",
										borderRadius: 8,
										boxShadow: "1px 2px 8px 1px #888",
									}}
								/>
								<span
									style={{
										backgroundColor: "#fff",
										color: "#fff",
										textTransform: "uppercase",
										padding: "16px",
										width: "65%",
										display: "block",
										textAlign: "center",
										margin: "0 auto",
										fontWeight: "bold",
										borderRadius: 30,
										marginTop: "-23%",
										zIndex: 1,
										position: "relative",
									}}
								></span>
								<span
									style={{
										backgroundColor: style.color,
										color: "#fff",
										textTransform: "uppercase",
										padding: "16px",
										width: "65%",
										display: "block",
										textAlign: "center",
										margin: "0 auto",
										fontWeight: "bold",
										borderRadius: 30,
										marginTop: "-5%",
										zIndex: 1,
										position: "relative",
									}}
								>
									buy
								</span>
							</Grid>
						)}
					</Grid>
				</div>
				<div
					style={{
						flexGrow: 1,
						background: "transparent",
						padding: 20,
					}}
				>
					<div
						style={{
							marginTop: 10,
							textAlign: "center",
							color: v.referralMessageColor,
						}}
					>
						{v.referralMessage}
					</div>
				</div>
				<BottomFloat style={{ marginLeft: 0, zIndex: 1, paddingBottom: 0 }}>
					<BottomNavigation
						showLabels
						onChange={(event, newValue) => {
							if (newValue === "claim") {
								v.openHowToClaim = true;
							} else if (newValue === "play") {
								v.openHowToPlay = true;
							} else if (newValue === "support") {
								var url = "https://sgpoolsretailer.com/support";
								if (process.env.REACT_APP_NAME !== "SGPools") {
									url = "https://sgpoolsretailer.com/sgbetsupport";
								}
								window.open(url, "_blank", "noopener,noreferrer");
							} else if (newValue === "4d-prize") {
								v.fourDPrizeModal = true;
							} else {
								hist.push(newValue);
							}
						}}
						style={{}}
					>
						<BottomNavigationAction
							label="Check Booking"
							value="/booking"
							icon={<ReceiptIcon />}
						/>
						{
							/* prettier-ignore */
							(parseInt(user?.agentSumWeek) >= 500 || user?.agent_lvl > -1) ? (
              <BottomNavigationAction
                label="Agent"
                value="/agent"
                icon={<MonetizationOnIcon />}
              />
            ) : null
						}

						<BottomNavigationAction
							label="Account"
							value="retailer-account"
							icon={<PaymentIcon />}
						/>
						{process.env.REACT_APP_NAME === "SGPools" ? (
							<BottomNavigationAction
								label="How to Play"
								value="play"
								icon={<ContactSupportIcon />}
							/>
						) : null}
						<BottomNavigationAction
							label="Whatsapp Support"
							value="support"
							icon={<SupportAgentIcon />}
						/>
						{process.env.REACT_APP_NAME === "SGBet" ? (
							<BottomNavigationAction
								label="4D Prize"
								value="4d-prize"
								icon={<EmojiEventsIcon />}
							/>
						) : null}

						{/* <BottomNavigationAction
							label="Credit History"
							value="credit-history"
							icon={<PaymentIcon />}
						/> */}
					</BottomNavigation>
				</BottomFloat>
			</Container>

			<Dialog
				open={v.openHowToClaim}
				onClose={() => {
					v.openHowToClaim = false;
				}}
			>
				<DialogTitle>How to claim a prize</DialogTitle>
				<DialogContent>
					<DialogContentText>
						1. If you are one of our lucky winners, you will receive a SMS from
						System the same day between 7pm - 10pm
					</DialogContentText>
					<DialogContentText>
						2. Winning amount will be credited to your retailer account, if you
						need further assistance kindly reach out to our support for
						assistance{" "}
						<Link to="https://sgpoolsretailer.com/support">
							https://sgpoolsretailer.com/support
						</Link>
					</DialogContentText>
					<DialogContentText>
						3. Same-day payout to your bank account, Yes! For Local Only,
						International users requires 3 business days.
					</DialogContentText>
					<DialogContentText>
						4. Transaction above SGD 200,000.00 kindly provide us with a Copy of
						your National ID/passport, Bearing your name and identification
						matching that of your bank records or you may drop by our outlet to
						collect your physical ticket
					</DialogContentText>
				</DialogContent>

				<DialogActions style={{ borderTop: "1px solid #eee" }}>
					<Button onClick={() => (v.openHowToClaim = false)}>Close</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={v.openHowToPlay}
				onClose={() => {
					v.openHowToPlay = false;
				}}
			>
				<DialogTitle>How to Play</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<AppBar position="static">
							<Tabs
								value={value}
								onChange={handleChange}
								aria-label="simple tabs example"
							>
								<Tab label="4D" {...a11yProps(0)} />
								<Tab label="Toto" {...a11yProps(1)} />
							</Tabs>
						</AppBar>
						<TabPanel value={value} index={0}>
							<ol>
								<li>
									To play 4D, select a four-digit number from 0000 to 9999.
								</li>
								<li>The minimum cost is SGD 1.00.</li>
								<li>
									Draws take place every Wednesday, Saturday and Sunday at
									6.30pm Singapore Time.
								</li>
								<li>
									23 sets of winning 4D numbers across five prize categories are
									drawn each draw.
								</li>
								<li>
									If you have placed bets on any of the 23 winning 4D numbers,
									you win a prize.
								</li>
							</ol>
						</TabPanel>
						<TabPanel value={value} index={1}>
							{/* <p style={{ color: "blue" }}>Coming Soon!</p> */}
							<ol>
								<li>
									To play TOTO, pick at least six numbers between 1 and 49.
								</li>
								<li>The minimum cost is SGD 1.00.</li>
								<li>
									Draws take place every Monday and Thursday at 6.30pm Singapore
									Time.
								</li>
								<li>
									Six Winning Numbers and one Additional Number are drawn each
									draw.
								</li>
								<li>
									If your chosen numbers include at least three of the Winning
									Numbers, you win a prize.
								</li>
								<li>
									If your bet type is Fatcat Match 2 with chosen number include
									at least two of the winning numbers, you win a prize.
								</li>
							</ol>
						</TabPanel>
					</DialogContentText>
				</DialogContent>
				<DialogTitle>How to claim a prize</DialogTitle>
				<DialogContent>
					<DialogContentText>
						1. If you are one of our lucky winners, you will receive a
						text/SMS/whatsapp from System the same day between 7pm - 10pm
					</DialogContentText>
					<DialogContentText>
						2. Winning amount will be credit to your retailer account, if you
						need further assistance kindly reach out to our support for
						assistance{" "}
						<a
							href="https://sgpoolsretailer.com/support"
							target="_blank"
							rel="noreferrer"
						>
							https://sgpoolsretailer.com/support
						</a>
					</DialogContentText>
					<DialogContentText>
						3. Same-day credit to your bank account, Yes! For Local Only,
						International users requires 3 business days.
					</DialogContentText>
					<DialogContentText>
						4. Transaction above SGD 200,000.00 kindly provide us with a Copy of
						your National ID/passport, Bearing your name and identification
						matching that of your bank records or you may drop by our outlet to
						collect your physical ticket
					</DialogContentText>
				</DialogContent>
				<DialogActions style={{ borderTop: "1px solid #eee" }}>
					<Button onClick={() => (v.openHowToPlay = false)}>Close</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={v.fourDPrizeModal}
				onClose={() => {
					v.fourDPrizeModal = false;
				}}
				className="fourd-prize-modal"
			>
				<DialogTitle>4D Prize</DialogTitle>
				<DialogContent>
					{prize4d?.ordinary !== undefined ? (
						<DialogContentText>
							<p>
								If you have placed bets on any of the 23 winning 4D numbers, you
								win a prize.
								<br />
								Your prize amount depends on the winning category, your bet
								amount and bet type. <br />
								The prize tables below calculate the prize amount for every $1
								bet.
							</p>
							<h3>Prize amounts for Ordinary Entry, System Entry or 4D Roll</h3>
							<div className="table">
								<table>
									<thead>
										<tr>
											<th>Prize Category</th>
											<th>Every $1 on Big bet</th>
											<th>Every $1 on Small bet</th>
										</tr>
									</thead>
									<tbody>
										{Object.entries(prize4d.ordinary).map((e, i) => (
											<tr key={i}>
												<td>{capitalize(e[0])}</td>
												<td>${e[1].big}</td>
												<td>${e[1].small}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							<h3>Prize amounts for iBet</h3>
							<p className="bold">Every $1 on Big bet</p>

							<div className="table table1">
								<table>
									<thead style={{ width: 2000 }}>
										<tr>
											<th>Prize Category</th>
											<th>4 different digits selected (e.g. 1234)</th>
											<th>
												2 different and 1 pair of digits selected (e.g. 1123)
											</th>
											<th>2 pairs of digits (e.g. 1122)</th>
											<th>3 of the same digits (e.g. 1112)</th>
										</tr>
									</thead>
									<tbody style={{ width: 2000 }}>
										{Object.entries(prize4d.ibet_big).map((e, i) => (
											<tr key={i}>
												<td>{capitalize(e[0])}</td>
												<td>${e[1].all_unique}</td>
												<td>${e[1]["1_pair"]}</td>
												<td>${e[1]["2_pair"]}</td>
												<td>${e[1].triple}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							<p className="bold">Every $1 on Small bet</p>

							<div className="table table2">
								<table
									style={{ scroll: "horizontal" }}
									className="table table-striped"
								>
									<thead>
										<tr>
											<th>Prize Category</th>
											<th>4 different digits selected (e.g. 1234)</th>
											<th>
												2 different and 1 pair of digits selected (e.g. 1123)
											</th>
											<th>2 pairs of digits (e.g. 1122)</th>
											<th>3 of the same digits (e.g. 1112)</th>
										</tr>
									</thead>
									<tbody>
										{Object.entries(prize4d.ibet_small).map((e, i) => (
											<tr key={i}>
												<td>{capitalize(e[0])}</td>
												<td>${e[1].all_unique}</td>
												<td>${e[1]["1_pair"]}</td>
												<td>${e[1]["2_pair"]}</td>
												<td>${e[1].triple}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</DialogContentText>
					) : null}
					<div style={{ textAlign: "center", marginBottom: 12 }}>
						<Button
							onClick={() => {
								v.fourDPrizeModal = false;
							}}
						>
							Close
						</Button>
					</div>
				</DialogContent>
			</Dialog>

			{(window.location.hostname.indexOf("chweetrading.com") > -1 ||
				window.location.hostname.indexOf("teokharbee.com") > -1 ||
				window.location.hostname.indexOf("sgpools.online") > -1) && (
				<Dialog open={true}>
					<DialogContent>
						<DialogContentText
							style={{
								display: "flex",
								alignItems: "center",
								flexDirection: "column",
							}}
						>
							<img
								src={
									process.env.REACT_APP_YES_APP === undefined
										? bow
										: process.env.REACT_APP_ASSETS3 + "bow.png?d=xxxxxxx"
								}
								style={{ width: 80, textAlign: "center" }}
								alt="Bow"
							/>
							<p style={{ textAlign: "center" }}>
								Sorry for the inconvenience. Currently, the site is facing some
								technical issue. We will re-direct you to our new site. Do not
								worry. Those with referral and your booking ID remained the
								same. <br />
								<br />
								Rest assured that our top priority is confidentiality for all of
								our clients. The whole structure of the new site is similar to
								the previous.
								<br />
								Thank you.
							</p>
						</DialogContentText>
					</DialogContent>
					<DialogActions style={{ justifyContent: "center" }}>
						<Button
							onClick={() => {
								window.location.href = "https://sgpools.com.sg/retailer";
							}}
						>
							Ok
						</Button>
					</DialogActions>
				</Dialog>
			)}
		</>
	);
});

export default Home2;
